import fileDownload from 'js-file-download';

import { formatYearToDayStandard } from 'utils/date/format.util';
import { nowAsMoment } from 'utils/date/now.util';
import asObject from 'utils/objects/asObject.util';

import { CLIENTS_CSV_FAILURE, CLIENTS_CSV_REQUEST, CLIENTS_CSV_SUCCESS } from './actions';

const generateFileName = () => `clientList-${formatYearToDayStandard(nowAsMoment())}.csv`;

const clientListReducer = (
  state = {
    clientList: {
      isFetching: false,
      errorMessage: '',
    },
  },
  action,
) => {
  const { type, errorMessage, response } = asObject(action);

  if (!type) return state;

  switch (type) {
    case CLIENTS_CSV_REQUEST:
      return { ...state, clientList: { isFetching: true, errorMessage: '' } };
    case CLIENTS_CSV_SUCCESS: {
      fileDownload(response, generateFileName()); // FIXME: remove side effect from reducer
      return { ...state, clientList: { isFetching: false, errorMessage: '' } };
    }
    case CLIENTS_CSV_FAILURE:
      return { ...state, clientList: { isFetching: false, errorMessage } };
    default:
      return state;
  }
};

export default clientListReducer;
